<template>
    <div class="barchart-color-picker relative">
        <div @click="show" class="color-block" :style="{'background-color': color}"></div>
        <color-picker-compact v-if="showPicker" @input="update" :value="color" class="z-50"></color-picker-compact>
        <i v-if="showPicker" @click="hide" class="fa fa-times text-md z-49 absolute inset-0 -ml-6 -mr-px px-2 py-1 bg-white border border-r-0 cursor-pointer text-left"></i>
    </div>
</template>

 <script setup>
import { ref, watch, onMounted } from 'vue';
import ColorPickerCompact from 'vue-color/src/components/Compact.vue';

const props = defineProps(['initialColor', 'opacity', 'modelValue']);
const emit = defineEmits(['update:modelValue']);

const color = ref(props.initialColor);
const alpha = ref(false);
const showPicker = ref(false);

watch(() => props.initialColor, (newValue) => {
    color.value = newValue;
});

function update(color) {
    if (props.opacity || alpha.value) {
        const opacity = props.opacity || alpha.value;

        color.value = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${opacity})`;
    } else {
        color.value = color.hex;
    }

    hide();
    emit('update:modelValue', color.value);
}

function parseRgba(value) {
    const results = value.match(/(0?\.?\d{1,3})%?\b/g).map(Number);
    const [r, g, b, a] = results;
    return { r, g, b, a };
}

function show() {
    showPicker.value = true;
}

function hide() {
    showPicker.value = false;
}

onMounted(() => {
    if (color.value.startsWith('rgba')) {
        const rgba = parseRgba(color.value);
        alpha.value = rgba.a;
    }
});
</script>

<style lang="scss">
.barchart-color-picker {
    @apply inline-flex m-0 p-0 border border-gray-400;

    .vc-compact {
        position: absolute;
        width: 246px;
        margin-top: -90%;
    }
    .color-block {
        @apply inline-flex rounded-sm border border-white;
        @apply w-6 h-auto;
        min-height: 1.36rem;
    }
}
</style>
